import React from 'react';
import { Row, Col, Table, Form } from 'react-bootstrap';
import Pagination from 'react-js-pagination';
import { useTranslation, Trans } from 'react-i18next';
import { DebounceInput } from 'react-debounce-input';
import { CurrencyPlainText,
  CurrencyDollarPlainText,
  CurrencyEuroPlainText } from 'helpers/Currency';
import { parseDateBR } from 'helpers/date';
import flatten from 'helpers/flatten';

const Listing = ({
  fields,
  data,
  filters,
  stateFilters,
  handleFilterChange,
  actions,
  filter
}) => {
  const { t } = useTranslation();
  const handlePageChange = page => handleFilterChange({ page });
  const getCurrencyTag = (value) => {
    switch (filter.currency_id) {
      case '1':
        return(<CurrencyPlainText
          className="text-center align-middle"
          value={value}
        />);
        break;
      case '2':
        return(<CurrencyDollarPlainText
          className="text-center align-middle"
          value={value}
        />);
        break;
      case '3':
        return(<CurrencyEuroPlainText
          className="text-center align-middle"
          value={value}
        />);
        break;
    
      default:
        break;
    }
  }
  return (
    <>
      <Row>
        <Col>
          <Row className="justify-content-end">
            {filters.map((filter, k) => (
              <Col key={k} md={3}>
                <Form.Group>
                  <Form.Label>{t(`label:${filter.name}`)}</Form.Label>
                  <Form.Control
                    value={stateFilters[filter.key]}
                    onChange={e =>
                      handleFilterChange({
                        [filter.key]: e.target.value,
                        page: 1
                      })
                    }
                    as="select"
                  >
                    {filter.name != "currency" ? 
                    <option value="">{t('label:all')}</option> : null }
                    {filter.options.map((option, k) => (
                      <option key={k} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Col>
            ))}
          </Row>
          <Row>
            <Col>
              <Table bordered hover responsive>
                <thead>
                  <tr>
                    {fields.map((field, k) => (
                      <th className="text-center align-middle" key={k}>
                        {t(`label:${field.name}`)}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {data.data.map((dt, k) => {
                    const data = flatten(dt);

                    return (
                      <tr key={k}>
                        {fields.map((field, k) => {
                          let text;

                          switch (field.type) {
                            case 'string':
                              text = !!data[field.key]
                                ? t(`statuses:${data[field.key]}`)
                                : '--';
                              break;
                            case 'date':
                              text = !!data[field.key]
                                ? parseDateBR(data[field.key])
                                : '--';
                              break;
                            case 'currency':
                              text = !!data[field.key] ? (
                                // <CurrencyPlainText
                                //   className="text-center align-middle"
                                //   value={parseFloat(data[field.key])}
                                // />
                                getCurrencyTag(parseFloat(data[field.key]))
                              ) : (
                                '--'
                              );
                              break;
                            case 'custom':
                              text = field.value(data, dt);
                              break;
                            default:
                              text = data[field.key];
                              break;
                          }

                          if (!!field.trans) text = t(`${field.trans}:${text}`);

                          return (
                            <td className="text-center align-middle" key={k}>
                              {text}
                            </td>
                          );
                        })}
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default Listing;
